<template>
	<div
		class="container-fluid conteudo"
		style="margin-bottom: 22px; padding-top: 16px"
	>
		<slot />
	</div>
</template>

<script>
export default {}
</script>
